import BaseOutgoingPayload from "./base-outgoing-payload.ts";
import OutgoingPayloadEvent from "../../enums/outgoing-payload-event.ts";

export default class V1GroupCreate extends BaseOutgoingPayload {
  constructor() {
    super(OutgoingPayloadEvent.V1_GROUP_CREATE);
  }
}
